import {
  Component,
  Input,
  Output,
  EventEmitter,
  Optional,
} from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Inject, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "../../../services/dialog.service";
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "compromissada-error",
  templateUrl: "./compromissada-error.component.html",
  styleUrls: ["./compromissada-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class CompromissadaErrorComponent implements OnInit {
  constructor() {}

  @Input() result: any;

  ngOnInit(): void {}

  ColumnsContracted: string[] = [
    "accountManagerName",
    "accountManagerDocument",
    "portfolioDocument",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "portfolioName",
    "portfolioSelicAccount",
    "operationTypeId",
    "returnDate",
    "unitPriceOutward",
    "valueOutward",
    "valueReturn",
    "amount",
    "operationValue",
    "security",
    "securityId",
    "expirationDate",
    "issueTax",
    "counterpartName",
    "counterpartSelicAccount",
    "command",
    "annotations",
  ];
}
